import React from "react";
import { useId } from "../../hooks/use-id";
import { FormValidations } from "../../util/form-validations";
import { FormMessage } from "../../components/shared/form-message";

/**
 * Campo de entrada para el correo electrónico del usuario.
 *
 * Renderiza el campo de correo, lo registra en React Hook Form y aplica
 * las validaciones de obligatoriedad y formato de correo electrónico.
 * En caso de que alguna validación falle, muestra el mensaje de error
 * correspondiente.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formController - Instancia de React Hook Form utilizada para registrar y validar el campo.
 * @param {Object} props.texts - Objeto con los textos traducidos utilizados en la interfaz.
 *
 * @returns {JSX.Element} InstEmailInput
 */
export const InstEmailInput = ({ formController, texts }) => {
    const emailInput = useId('emailInput');

    // Identificador utilizado por React Hook Form para registrar el campo.
    const fieldEmail = 'emailInput';
    const { institucional } = texts;
    const { correo } = institucional;

    const {
        register,
        formState: { errors } } = formController

    return (
        <>
            <label
                htmlFor={emailInput}
                className="secondary-item"
            >
                <strong>{correo?.label || 'Correo electrónico*:'}</strong>
            </label>
            <input
                type="email"
                className="form-control focusable-secondary"
                id={emailInput}
                placeholder={correo?.placeholder || "usuario@correo.com"}
                defaultValue=""
                {...register(
                    fieldEmail,
                    {
                        required: {
                            value: true,
                            message: correo?.alert || 'Por favor, escribe tu correo electrónico'
                        },
                        validate: (value) => FormValidations.multipleValidations([
                            {
                                validation: FormValidations.validEmail({ email: value }),
                                errorMessage: correo?.validation || 'Por favor escribe un correo electrónico válido'
                            },
                        ])
                    }
                )}
            />

            <FormMessage
                message={errors[fieldEmail]?.message}
                type={"error"}
            />
        </>
    )
}